__turbopack_context__.v({
  "aside": "CaseStudySlider-module__c5YJGa__aside",
  "card": "CaseStudySlider-module__c5YJGa__card",
  "cardCopy": "CaseStudySlider-module__c5YJGa__cardCopy",
  "cardText": "CaseStudySlider-module__c5YJGa__cardText",
  "cardTitle": "CaseStudySlider-module__c5YJGa__cardTitle",
  "cardValue": "CaseStudySlider-module__c5YJGa__cardValue",
  "corner": "CaseStudySlider-module__c5YJGa__corner",
  "counter": "CaseStudySlider-module__c5YJGa__counter",
  "feature": "CaseStudySlider-module__c5YJGa__feature",
  "featureCopy": "CaseStudySlider-module__c5YJGa__featureCopy",
  "featureText": "CaseStudySlider-module__c5YJGa__featureText",
  "featureTitle": "CaseStudySlider-module__c5YJGa__featureTitle",
  "head": "CaseStudySlider-module__c5YJGa__head",
  "image": "CaseStudySlider-module__c5YJGa__image",
  "kicker": "CaseStudySlider-module__c5YJGa__kicker",
  "nav": "CaseStudySlider-module__c5YJGa__nav",
  "navButton": "CaseStudySlider-module__c5YJGa__navButton",
  "photo": "CaseStudySlider-module__c5YJGa__photo",
  "section": "CaseStudySlider-module__c5YJGa__section",
  "slide": "CaseStudySlider-module__c5YJGa__slide",
  "stars": "CaseStudySlider-module__c5YJGa__stars",
  "stat": "CaseStudySlider-module__c5YJGa__stat",
  "statLabel": "CaseStudySlider-module__c5YJGa__statLabel",
  "statValue": "CaseStudySlider-module__c5YJGa__statValue",
  "stats": "CaseStudySlider-module__c5YJGa__stats",
  "track": "CaseStudySlider-module__c5YJGa__track",
});
